import React from 'react';
import jwt_decode from 'jwt-decode';
import axios from 'axios';
import Swal from 'sweetalert2';
import {
    FacebookLoginButton, GoogleLoginButton, TwitterLoginButton, LinkedInLoginButton, InstagramLoginButton
} from "react-social-login-buttons";

import { loginRequest } from "../services/authConfig";
import { callMsGraph } from "../services/graph";
import { MsalContext } from "@azure/msal-react";
import { InteractionStatus } from "@azure/msal-browser";

import PropTypes from 'prop-types';

import EsLogo from '../assets/img/Es.svg';

import { createBrowserHistory } from 'history';
import { authService } from '../services/auth.service';
import CasClient, { constant } from "react-cas-client";
const history = createBrowserHistory();
const [CAS_PROTOCOL, CAS_SERVER] = (process.env.REACT_APP_CAS_URL).split("://");
const casOptions = { version: constant.CAS_VERSION_2_0, path: '/', protocol: CAS_PROTOCOL };
const casClient = new CasClient(CAS_SERVER, casOptions);

const SERVER_URL = process.env.REACT_APP_SERVER_URL;
const REDIRECT_URL = process.env.REACT_APP_REDIRECT_URL;
const GOOGLE_ID = process.env.REACT_APP_GOOGLE_ID;
const GOOGLE_API_KEY = process.env.REACT_APP_GOOGLE;
const FACEBOOK_APP_ID = process.env.REACT_APP_FACEBOOK_ID;
const FACEBOOK_GRAPH_API_V = process.env.REACT_APP_GRAPH_API_VERSION;
const LINKEDIN_APP_ID = process.env.REACT_APP_LINKEDIN_ID;
const LINKEDIN_APP_SECRET = process.env.REACT_APP_LINKEDIN_SECRET;
const LINKEDIN_STATE = process.env.REACT_APP_LINKEDIN_STATE;
const TWITTER_APP_ID = process.env.REACT_APP_TWITTER_ID;
const TWITTER_STATE = process.env.REACT_APP_TWITTER_STATE;
const INSTAGRAM_APP_ID = process.env.REACT_APP_INSTAGRAM_ID;
const INSTAGRAM_APP_SECRET = process.env.REACT_APP_INSTAGRAM_SECRET;
const INSTAGRAM_REDIRECT = process.env.REACT_APP_INSTAGRAM_REDIRECT;

export class LoginRedes extends React.Component {

    abortController = new window.AbortController();

    constructor(props) {
        super(props);

        this.state = {
            redClickeada: "",
            username: null,
            currentUser: null
        }

        // METODOS
        this.getLoginMessage = this.getLoginMessage.bind(this);
        this.getCodeFromWindowURL = this.getCodeFromWindowURL.bind(this);
        // *********************** GOOGLE
        this.googleLogin = this.googleLogin.bind(this);
        this.handleGoogleCallbackResponse = this.handleGoogleCallbackResponse.bind(this);
        // *********************** FACEBOOK
        this.checkFacebookLoginStatus = this.checkFacebookLoginStatus.bind(this);
        this.facebookStatusChangeCallback = this.facebookStatusChangeCallback.bind(this);
        this.fetchDataFacebook = this.fetchDataFacebook.bind(this);
        this.facebookLogin = this.facebookLogin.bind(this);
        // *********************** LINKEDIN
        this.linkedinLogin = this.linkedinLogin.bind(this);
        this.getLinkedinAccessToken = this.getLinkedinAccessToken.bind(this);
        this.getLinkedinEmail = this.getLinkedinEmail.bind(this);
        this.fetchDataLinkedin = this.fetchDataLinkedin.bind(this);
        // *********************** TWITTER
        this.twitterLogin = this.twitterLogin.bind(this);
        this.getTwitterAccessToken = this.getTwitterAccessToken.bind(this);
        this.getTwitterEmail = this.getTwitterEmail.bind(this);
        // *********************** ESPOL
        this.azureLogin = this.azureLogin.bind(this);
        this.azureGetDatosUser = this.azureGetDatosUser.bind(this);
        // *********************** INSTAGRAM
        this.instagramLogin = this.instagramLogin.bind(this);
        this.getInstagramAccessToken = this.getInstagramAccessToken.bind(this);
        this.getInstagramUser = this.getInstagramUser.bind(this);
    }

    componentDidMount() {

        if (window.opener && window.opener !== window) {
            const code = this.getCodeFromWindowURL(window.location.href);
            window.opener.postMessage({ 'type': 'code', 'code': code }, '*')
            window.close();
        }

        //if (window.location.href.includes("auth.espol.edu.ec")) {
        //    const { username } = this.state;
        //    if (!username) {
        //        this.casLogin();
        //    }
        //}

        window.addEventListener('message', this.getLoginMessage);

        // **************************************************** CARGAR GOOGLE
        //console.log("GOOGLE_ID: ", GOOGLE_ID);

        /* global google */
        google.accounts.id.initialize({
            client_id: GOOGLE_ID,
            prompt: 'select_account',
            callback: this.handleGoogleCallbackResponse
        });

        // google's button
        google.accounts.id.renderButton(
            document.getElementById("signInDiv"),
            { theme: "outline", size: "large", text: "Iniciar sesión con Google", logo_alignment: "center" }
        );

        // **************************************************** CARGAR FACEBOOK
        window.fbAsyncInit = function () {
            window.FB.init({
                appId: FACEBOOK_APP_ID, //PruebaLogin2
                cookie: true,
                xfbml: true,
                version: FACEBOOK_GRAPH_API_V
            });

            window.FB.AppEvents.logPageView();
        };

        (function (d, s, id) {
            var js, fjs = d.getElementsByTagName(s)[0];
            if (d.getElementById(id)) { return; }
            js = d.createElement(s); js.id = id;
            js.src = "https://connect.facebook.net/en_US/sdk.js";
            fjs.parentNode.insertBefore(js, fjs);
        }(document, 'script', 'facebook-jssdk'));

        // **************************************************** CAS ESPOL
        const isAuthenticated = this.context.accounts.length > 0;
        console.log('isAuthenticated: ', isAuthenticated);

        if (isAuthenticated) {
            Swal.fire({
                title: 'Buscando su información...',
                allowOutsideClick: false,
                allowEscapeKey: false,
                didOpen: () => {
                    Swal.showLoading()
                }
            });

            this.azureGetDatosUser();
        }

        //this.subscription = authService.currentUser.subscribe(currentUser => {
        //    if (currentUser) {
        //        this.setState({ currentUser: currentUser });
        //    }
        //});
    }

    componentDidUpdate() {
  //      const isAuthenticated = this.context.accounts.length > 0;
  //      console.log('isAuthenticated: ', isAuthenticated);

  //      if (isAuthenticated) {
  //          Swal.fire({
  //              title: 'Buscando su información...',
  //              allowOutsideClick: false,
  //              allowEscapeKey: false,
  //              didOpen: () => {
  //                  Swal.showLoading()
  //              }
  //          });

  //          this.azureGetDatosUser();
		//}
    }

    getLoginMessage(event) {

        // AQUI DEBE IR LA LLAMADA AL RETRIEVE ACCESS TOKEN PARA LAS APLICACIONES
        if (event.data.type === 'code') {
            const { code } = event.data;
            this.getInstagramAccessToken(code);
        }

        //if (this.state.redClickeada === "L" && event.data.code !== undefined) {
        //    this.fetchDataLinkedin(event.data.code);
        //}

        //if (event.origin.includes("facebook")) {
        //    this.checkFacebookLoginStatus();
        //}

        //if (window.opener && window.opener !== window) {
        //    const code = this.getCodeFromWindowURL(window.location.href);
        //    console.log("getLoginMessage: ", code);
        //    window.opener.postMessage({ 'type': 'code', 'code': code }, '*')
        //    window.close();
        //}
    }

    getCodeFromWindowURL(url) {
        const popupWindowURL = new URL(url);
        return popupWindowURL.searchParams.get("code");
    }

    googleLogin() {
        /* global google */
        google.accounts.id.prompt();
        //google.accounts.oauth2.initTokenClient({
        //    client_id: GOOGLE_ID,
        //    scope: "THE_REQUESTED_SCOPES",
        //    prompt: 'select_account', // '' | 'none' | 'consent' | 'select_account'
        //    callback: this.handleGoogleCallbackResponse // your function to handle the response after login. 'access_token' will be returned as property on the response
        //});
    }

    handleGoogleCallbackResponse(response) {
        var decodedJWT = jwt_decode(response.credential);

        Swal.fire({
            title: 'Buscando su información...',
            allowOutsideClick: false,
            allowEscapeKey: false,
            didOpen: () => {
                Swal.showLoading()
            }
        });

        this.props.closeLoginRedes("G", decodedJWT.email);
    }

    checkFacebookLoginStatus(event) {
        event.preventDefault();
        this.setState({ redClickeada: "F" }, () => { console.log("Facebook"); });

        window.FB.getLoginStatus(function (response) {
            this.facebookStatusChangeCallback(response);
        }.bind(this));

        return false;
    }

    facebookStatusChangeCallback(response) {
        if (response.status === "connected") {
            Swal.fire({
                title: 'Buscando su información...',
                allowOutsideClick: false,
                allowEscapeKey: false,
                didOpen: () => {
                    Swal.showLoading()
                }
            });

            this.fetchDataFacebook();

        } else if (response.status === "not_authorized ") {
            Swal.fire({
                title: 'Oh no!',
                text: 'Por favor autorice la aplicación para continuar con el proceso.',
                icon: 'warning',
                confirmButtonText: 'OK',
                allowOutsideClick: false,
                allowEscapeKey: false,
            }).then((result) => {
                if (result.isConfirmed) {
                    Swal.close();
                }
            });

        } else {
            this.facebookLogin();
            //Swal.fire({
            //    title: 'Oh no!',
            //    text: 'Error al iniciar sesión.',
            //    icon: 'error',
            //    confirmButtonText: 'OK',
            //    allowOutsideClick: false,
            //    allowEscapeKey: false,
            //}).then((result) => {
            //    if (result.isConfirmed) {
            //        Swal.close();
            //    }
            //});
        }
    }

    fetchDataFacebook() {
        window.FB.api('/me', { fields: 'id,name,email,picture' }, function (user) {
            this.props.closeLoginRedes("F", user.email);
        }.bind(this));
    }

    facebookLogin() {
        window.FB.login(function (response) {
            this.facebookStatusChangeCallback(response);
        }.bind(this), { scope: 'public_profile,email', return_scopes: true });
    }

    linkedinLogin() {
        this.setState({ redClickeada: "L" }, () => { console.log("LinkedIn"); });

        const oauthUrl = 'https://www.linkedin.com/oauth/v2/authorization?response_type=code';
        const redirectUrl = 'http://localhost:37746';
        const scope = 'r_liteprofile%20r_emailaddress';
        const state = 'f0rm7l4ri04Lu2n1'; //A unique string value of your choice that is hard to guess.Used to prevent CSRF.For example, state = DCEeFWf45A53sdfKef424.
        const loginUrl = `${oauthUrl}&client_id=${LINKEDIN_APP_ID}&scope=${scope}&state=${LINKEDIN_STATE}&redirect_uri=${redirectUrl}`;
        const width = 450,
            height = 730,
            left = window.screen.width / 2 - width / 2,
            top = window.screen.height / 2 - height / 2;
        this.popup = window.open(
            loginUrl,
            'Linkedin',
            'menubar=no,location=no,resizable=no,scrollbars=no,status=no, width=' + width +
            ', height=' + height +
            ', top=' + top +
            ', left=' + left
        );
    }

    getLinkedinAccessToken(code) {

        const datosbody = JSON.stringify({ "code": code, "clientid": LINKEDIN_APP_ID, "clientsecret": LINKEDIN_APP_SECRET });
        //console.log("datosbody: ", datosbody);

        //fetch("/api/Login/GetLinkedinAccessToken", {
        //    method: "POST", body: datosbody, headers: { 'Content-Type': 'application/json' }
        //})
        //    .then(response => response.json())
        //    .then(responsejson => {
        //        console.log("getLinkedinAccessToken: ", responsejson);
        //        if (responsejson["strEstado"] === "S") {

        //        }
        //    });

        fetch(SERVER_URL + "Informacion/GetLinkedInAccessToken", {
            signal: this.abortController.signal, method: "POST", body: datosbody, headers: { 'Content-Type': 'application/json' }
        })
            .then(response => response.json())
            .then(responseJson => {
                //console.log("responseJson: ", responseJson);
            });
    }

    getLinkedinEmail(accessToken) {
        var email = null;
        const config = {
            headers: {
                "Authorization": `Bearer ${accessToken}`
            }
        };
        axios.get('https://api.linkedin.com/v2/clientAwareMemberHandles?q=members&projection=(elements*(primary,type,handle~))', config)
            .then(response => {
                //console.log("email response", response);
                email = response.data.elements[0]["handle~"];
            })
            .catch(error => console.log("Error getting user email"))

        return email;
    }

    fetchDataLinkedin(code) {
        var accessToken = this.getLinkedinAccessToken(code);
        //var email = this.getLinkedinEmail(accessToken);
    }

    twitterLogin() {
        this.setState({ redClickeada: "T" }, () => { console.log("Twitter"); });

        const oauthUrl = 'https://twitter.com/i/oauth2/authorize?response_type=code';
        const redirectUrl = 'http://localhost:37746/';
        const scope = 'tweet.read%20users.read%20follows.read';
        const code_challenge = "Tw1t7Er23Log1u4utk0riZ4t10on";
        const loginUrl = `${oauthUrl}&client_id=${TWITTER_APP_ID}&redirect_uri=${REDIRECT_URL}&scope=${scope}&state=${TWITTER_STATE}&code_challenge=${code_challenge}&code_challenge_method=plain`;
        const width = 450,
            height = 730,
            left = window.screen.width / 2 - width / 2,
            top = window.screen.height / 2 - height / 2;

        this.popup = window.open(
            loginUrl,
            'Twitter',
            'menubar=no,location=no,resizable=no,scrollbars=no,status=no, width=' + width +
            ', height=' + height +
            ', top=' + top +
            ', left=' + left
        );
    }

    getTwitterAccessToken(code) {
        var accessToken = null;
        const config = {
            headers: { "Content-Type": 'application/x-www-form-urlencoded' }
        };
        const parameters = JSON.stringify({
            "grant_type": "authorization_code",
            "code": code,
            "redirect_uri": REDIRECT_URL,
            "client_id": LINKEDIN_APP_ID,
            "code_verifier": 'challenge',
        });

        axios.post('https://api.twitter.com/2/oauth2/token', parameters, config)
            .then(response => {
                //console.log("accessToken response: ", response);
                //accessToken = response.data["access_token"];
            })
            .catch(err => {
                console.log("Error getting LinkedIn access token");
            })
        return accessToken;
    }

    getTwitterEmail(accessToken) {
        var email = null;
        const config = {
            headers: {
                "Authorization": `Bearer ${accessToken}`
            }
        };
        axios.get('https://api.twitter.com/2/users/me', config)
            .then(response => {
                //console.log("email response", response);
                //email = response.data.elements[0]["handle~"];
            })
            .catch(error => console.log("Error getting user email"))

        return email;
    }

    fetchDataTwitter(code) {
        //{
        //    "data": {
        //        "id": "1547228779579408385",
        //            "name": "Prueba Prueba",
        //                "username": "PruebaP22"
        //    }
        //}
        var accessToken = this.getTwitterAccessToken(code);
        var email = this.getTwitterEmail(accessToken);
    }

    async azureLogin() {
        const msalInstance = this.context.instance;

        await msalInstance.loginRedirect(loginRequest).catch(e => {
            console.log(e);
        });
    }

    async azureGetDatosUser() {
        const msalInstance = this.context.instance;

        await msalInstance
            .acquireTokenSilent({
                ...loginRequest,
                account: this.context.accounts[0],
            })
            .then((response) => {
                console.log(response);
                callMsGraph(response.accessToken).then((response) => {
                    var username = response.mail.split('@');

                    // LLAMADA A API QUE RETORNE NUMERO DE IDENTIFCACION
                    fetch(SERVER_URL + `Informacion/GetDatosByUser/${username[0]}`, { signal: this.abortController.signal })
                        .then(response => response.json())
                        .then(responseJson => {
                            if (responseJson["strEstado"] === "S") {
                                //this.props.closeLoginEspol(username, responseJson["objeto"]);
                                this.props.closeLoginEspol(responseJson["objeto"]);

                            } else {
                                Swal.fire({
                                    title: 'Oh no!',
                                    text: 'Se ha producido un error al momento de obtener su información',
                                    icon: 'error',
                                    confirmButtonText: 'OK',
                                    allowOutsideClick: false,
                                    allowEscapeKey: false,
                                }).then((result) => {
                                    if (result.isConfirmed) {
                                        Swal.close();
                                    }
                                });
                            }
                        }, error => {
                            if (error.name === "AbortError") {
                                console.log("AbortError controlado");
                            } else {
                                //cargaExitosa = false;
                                var mensaje = "Ocurrió un error al obtener la información.";
                                //this.setState({ cedulaModal: true, cedulaAlert: true, mensajeAlerta: mensaje, cargandoValidAlert: false });
                                console.log("Ocurrió un error en fetchEspolData: " + error);

                                Swal.fire({
                                    title: 'Oh no!',
                                    text: 'Se ha producido un error al momento de obtener su información',
                                    icon: 'error',
                                    confirmButtonText: 'OK',
                                    allowOutsideClick: false,
                                    allowEscapeKey: false,
                                }).then((result) => {
                                    if (result.isConfirmed) {
                                        Swal.close();
                                    }
                                });
                            }
                        });
                });
            });
    }

    //checkEspolLoginStatus() {
    //    const { username } = this.state;
    //    if (!username) {
    //        this.casLogin();
    //    }
    //}

    //fetchEspolData() {
    //    const { username, currentUser } = this.state;
    //    if (username && currentUser && currentUser.usuario == "") {
    //        // LLAMADA A API QUE RETORNE NUMERO DE IDENTIFCACION
    //        fetch(SERVER_URL + `Informacion/GetDatosByUser/${username}`, { signal: this.abortController.signal })
    //            .then(response => response.json())
    //            .then(responseJson => {
    //                if (responseJson["strEstado"] === "S") {
    //                    //this.props.closeLoginEspol(username, responseJson["objeto"]);
    //                    this.props.closeLoginEspol(responseJson["objeto"]);

    //                } else {
    //                    Swal.fire({
    //                        title: 'Oh no!',
    //                        text: 'Se ha producido un error al momento de obtener su información',
    //                        icon: 'error',
    //                        confirmButtonText: 'OK',
    //                        allowOutsideClick: false,
    //                        allowEscapeKey: false,
    //                    }).then((result) => {
    //                        if (result.isConfirmed) {
    //                            Swal.close();
    //                        }
    //                    });
    //                }
    //            }, error => {
    //                if (error.name === "AbortError") {
    //                    console.log("AbortError controlado");
    //                } else {
    //                    //cargaExitosa = false;
    //                    var mensaje = "Ocurrió un error al obtener la información.";
    //                    //this.setState({ cedulaModal: true, cedulaAlert: true, mensajeAlerta: mensaje, cargandoValidAlert: false });
    //                    console.log("Ocurrió un error en fetchEspolData: " + error);

    //                    Swal.fire({
    //                        title: 'Oh no!',
    //                        text: 'Se ha producido un error al momento de obtener su información',
    //                        icon: 'error',
    //                        confirmButtonText: 'OK',
    //                        allowOutsideClick: false,
    //                        allowEscapeKey: false,
    //                    }).then((result) => {
    //                        if (result.isConfirmed) {
    //                            Swal.close();
    //                        }
    //                    });
    //                }
    //            });
    //    }
    //}

    //casLogin(gateway = false) {
    //    casClient
    //        .auth(gateway)
    //        .then(successRes => {
    //            this.setState({ username: successRes.user });
    //            history.replace(successRes.currentPath);
    //            // PROBAR FETCH
    //        })
    //        .catch(errorRes => {
    //            history.replace(errorRes.currentPath);
    //        });
    //}

    //casLogout() {
    //    authService.signout();
    //    casClient.logout();
    //}

    instagramLogin() {
        this.setState({ redClickeada: "I" }, () => { console.log("Instagram"); });

        const oauthUrl = 'https://api.instagram.com/oauth/authorize?';
        //const redirectUrl = 'https://localhost:44345/';
        const redirectUrl = INSTAGRAM_REDIRECT;
        const scope = 'user_profile%2Cuser_media'; //%2C coma
        const state = 'f0rm7l4ri04Lu2n1'; //A unique string value of your choice that is hard to guess.Used to prevent CSRF.For example, state = DCEeFWf45A53sdfKef424.
        const loginUrl = `${oauthUrl}&client_id=${INSTAGRAM_APP_ID}&redirect_uri=${redirectUrl}&scope=${scope}&response_type=code`;
        const width = 450,
            height = 730,
            left = window.screen.width / 2 - width / 2,
            top = window.screen.height / 2 - height / 2;
        this.popup = window.open(
            loginUrl,
            'Instagram',
            'menubar=no,location=no,resizable=no,scrollbars=no,status=no, width=' + width +
            ', height=' + height +
            ', top=' + top +
            ', left=' + left
        );
    }

    getInstagramAccessToken(code) {

        const datosbody = JSON.stringify({
            "clientid": "",
            "clientsecret": "",
            "code": code
        });
        //console.log("datosbody: ", datosbody);

        Swal.fire({
            title: 'Buscando su información...',
            allowOutsideClick: false,
            allowEscapeKey: false,
            didOpen: () => {
                Swal.showLoading()
            }
        });

        fetch(SERVER_URL + "Informacion/GetInstagramAccessToken", {
            method: 'POST', body: datosbody, headers: { 'Content-Type': 'application/json' } //headers: { 'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8' }
        })
            .then(response => response.json())
            .then(responseJson => {
                //console.log("IG token response: ", responseJson);
                if (responseJson["strEstado"] === "S") {
                    console.log("exito access_token");
                    this.getInstagramUser(responseJson.objeto.access_token, responseJson.objeto.user_id);
                } else {
                    Swal.fire({
                        title: 'Oh no!',
                        text: 'Se ha producido un error al momento de obtener su información de inicio de sesión',
                        icon: 'error',
                        confirmButtonText: 'OK',
                        allowOutsideClick: false,
                        allowEscapeKey: false,
                    }).then((result) => {
                        if (result.isConfirmed) {
                            Swal.close();
                        }
                    });
                }
            }, error => {
                console.log("Error al obtener el access token: ", error);
            });
    }

    getInstagramUser(token, userid) {
        //console.log("token: ", token);
        //console.log("userid: ", userid);

        fetch("https://graph.instagram.com/" + userid + "?fields=id,username&access_token=" + token, {
            signal: this.abortController.signal
        })
            .then(response => response.json())
            .then(responseJson => {
                //console.log("IG user response: ", responseJson);
                this.props.closeLoginRedes("I", responseJson.username);
            }, error => {
                console.log("Error al obtener user: ", error);

                Swal.fire({
                    title: 'Oh no!',
                    text: 'Se ha producido un error al momento de obtener su información de inicio de sesión',
                    icon: 'error',
                    confirmButtonText: 'OK',
                    allowOutsideClick: false,
                    allowEscapeKey: false,
                }).then((result) => {
                    if (result.isConfirmed) {
                        Swal.close();
                    }
                });
            });
    }

    render() {
        return (
            <>
                <div className="form-group row">
                    <div className="col-12 introduccion">
                        {(this.props.actDatos) && (
                            <p>Mantente conectado con Alumni ESPOL para que conozcas todos los eventos y beneficios que estamos preparando para ti.</p>
                        )}
                        {!(this.props.actDatos) && (
                            <p>
                                La encuesta de Seguimiento a Graduados nos permite conocer nuestro impacto en tu carrera profesional
                                y es un insumo para nuestro posicionamiento en rankings.
                                Pensando en la seguridad de tus datos, implementamos una verificaci&oacute;n de identidad.
                            </p>
                        )}
                    </div>
                    <div className="col-12 introduccion">
                        {(this.props.actDatos) && (
                            <p>¡Siempre en contacto, siempre juntos!</p>
                        )}
                        {!(this.props.actDatos) && (
                            <p> ¡La encuesta no toma m&aacute;s de 3 minutos!  ¡Gracias por ese tiempo!</p>
                        )}
                    </div>
                </div>
                <div className="form-group row">
                    <div className="col-12 mb-3 login-button">
                        <div className="col-md-6 col-12">
                            {/*<GoogleLoginButton className="login-button" onClick={this.googleLogin}><span>Iniciar sesión con Google</span></GoogleLoginButton>*/}
                            <div id="signInDiv" className="login-button"></div>
                        </div>
                    </div>
                    <div className="col-12 mb-3 login-button">
                        <div className="col-md-6 col-12">
                            <FacebookLoginButton className="login-button fb-button" onClick={this.facebookLogin}><span>Iniciar sesi&oacute;n con Facebook</span></FacebookLoginButton>
                        </div>
                    </div>
                    {/*<div className="col-12 mb-3 login-button">*/}
                    {/*    <div className="col-md-6 col-12">*/}
                    {/*        <InstagramLoginButton className="login-button fb-button" onClick={this.instagramLogin}><span>Iniciar sesi&oacute;n con Instagram</span></InstagramLoginButton>*/}
                    {/*    </div>*/}
                    {/*</div>*/}
                    <div className="col-12 mb-3 login-button">
                        <div className="col-md-6 col-12">
                            <button type="button"
                                style={{
                                    backgroundColor: "#233265", borderRadius: "3px", boxShadow: "rgba(0, 0, 0, 0.5) 0px 1px 2px",
                                    color: "#ffffff", width: "calc(100% - 10px)", height: "50px", margin: "5px", border: "0"
                                }} onClick={this.azureLogin}>
                                {/*<ES_Logo width={30} height={30} id="logo-es" style={{ transform: "rotate(35deg)" }} />&nbsp;&nbsp;Iniciar sesi&oacute;n con cuenta ESPOL*/}
                                <img src={EsLogo} alt="Espol Logo" width={30} height={30} id="logo-es" style={{ transform: "rotate(35deg)" }} />&nbsp;&nbsp;Iniciar sesi&oacute;n con cuenta ESPOL
                                </button>
                        </div>
                    </div>
                </div>
            </>
        );
    }
}

LoginRedes.propTypes = {
    closeLoginRedes: PropTypes.func
}

export default LoginRedes;
LoginRedes.contextType = MsalContext;